import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {sendOTP, validateProcess} from "../../../store/verification.slice";
import EmailInput from "./EmailInput";
import Loading from "../../reusable/Loading";
import CodeValidator from "../../reusable/CodeValidator";
import {useSelector} from "react-redux";
import {trackEvent} from "../../../utils/analytics";


function EmailCheck({inputChange, verification}) {
    const { t } = useTranslation();
    const [codeSent, setCodeSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [emailInput, setEmailInput] = useState("");
    const [validationErr, setValidationErr] = useState("");
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const {credentials} = useSelector((store) => store.verification);


    const sendOtp = () => {
        setLoading(true)
        setError("")
        setValidationErr("")
        setCodeSent(false)
        sendOTP(emailInput, params.get('clientId'), params.get('flowId'), verification?.verificationId,
            credentials?.accessToken).then(() => {
            trackEvent("email_otp_sent", {flowId: verification?.flowId, verificationId: verification?.verificationId})
            setLoading(false)
            setCodeSent(true)
        }).catch(err => {
            console.error("sendOTP failed", err)
            trackEvent("email_otp_send_failed", {flowId: verification?.flowId, verificationId: verification?.verificationId, error: err + ""})
            setCodeSent(false)
            setLoading(false)
            setError(t("emailCheck.sendError"))
        })
    }

    const validateEmailCheck = (code) => {
        setLoading(true)
        validateProcess("EMAIL_CHECK",
            [], [
                {fieldName: "EMAIL_ADDRESS", value: emailInput},
                {fieldName: "OTP_CODE", value: code}
            ], params.get('clientId'), verification?.verificationId, credentials?.accessToken).then(() => {
            trackEvent("email_otp_verified", {flowId: verification?.flowId, verificationId: verification?.verificationId})
            setLoading(false)
            inputChange(
                [{
                    document: null,
                    field: {
                        fieldName: "EMAIL_ADDRESS",
                        value: emailInput
                    }
                },
                    {
                        document: null,
                        field: {
                            fieldName: "OTP_CODE",
                            value: code
                        }
                    }
                ])
        }).catch(err => {
            setLoading(false)
            let validationErr;
            if (err.response && err.response.data) {
                const errors = err.response.data;
                // Assuming errors is an array of error objects
                validationErr = errors.map(error => error?.defaultMessage).join('\n');
            } else {
                // Handle unexpected error format
                validationErr = t("emailCheck.unexpectedError");
            }
            trackEvent("email_otp_verify_failed", {flowId: verification?.flowId, verificationId: verification?.verificationId, error: validationErr})
            setValidationErr(validationErr);
        })
    }

    const resendOtp = () => {
        setError("")
        setValidationErr("")
        trackEvent("email_otp_resent", {flowId: verification?.flowId, verificationId: verification?.verificationId})
        sendOTP(emailInput, params.get('clientId'), params.get('flowId'), verification?.verificationId,
            credentials?.accessToken).catch(err => {
            console.error("resendOTP failed", err)
            setError("Failed to resend code. Please try again.")
        })
    }

    const goback = () => {
        setCodeSent(false)
        setLoading(false)
    }

    return (
        <div className="h-full w-full">
            {((!codeSent && !loading) || (error)) && <EmailInput sendOtp={sendOtp} error={error} setEmailInput={setEmailInput} />}
            {codeSent && <CodeValidator sendCode={resendOtp} title={t("emailCheck.verifyTitle")} target={emailInput} validationErr={validationErr} goback={goback}
                                        validate={validateEmailCheck}/>}
            {loading && <Loading/>}
        </div>
    );
}

export default EmailCheck;
